'use client'

import React, { FunctionComponent, ReactNode } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Route } from 'next'
import { AnchorButton } from '@/app/_components/AnchorButton'
import { EVENTS_CHECKOUT_BASE_PATH, EVENTS_SLUG_POSTFIX, PORTAL_SELECTORS, STEP_SLUG } from '@/config/navigation.config'
import { Portal } from '@/app/_components/Portal/Portal'
import { useCart } from '@/app/_providers/CartProvider/CartProvider'
import { cartExists } from '@/utils/cart.utils'
import TXT from '@/messages'

type Props = {
  sellerSlug: string
}

type RefProps = {
  href: Route
}

const RefButton = ({ href }: RefProps ): ReactNode => (
  <Link href={href} passHref>
    <AnchorButton
      weight="semibold"
      aria-label={TXT.a11y.goToCart}
      size="sm"
      className="cart-button"
      data-testid="header-cart-button"
      icon={(
        <Image width={24} height={24} aria-hidden="true" src="/static/svg/cart.svg" alt={TXT.a11y.goToCart} />
      )}
    >
      {TXT.siteChrome.cart}
    </AnchorButton>
  </Link>
)

const CartButton: FunctionComponent<Props> = ({ sellerSlug }: Props) => {
  const { cart } = useCart()

  if (!sellerSlug || !cartExists(cart)) {
    return null
  }

  return (
    <Portal selector={`#${PORTAL_SELECTORS.cartButton}`}>
      <RefButton href={`/${sellerSlug}/${EVENTS_SLUG_POSTFIX}/${EVENTS_CHECKOUT_BASE_PATH}/${STEP_SLUG.CustomerInfo}` as Route} />
    </Portal>
  )
}

export default CartButton
